var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("mds-combo-box", {
        attrs: {
          label: "Select your regional calendar",
          placeholder: "Select an Option",
          size: "small",
          "selected-items": [_vm.selectedCountry],
          "data-set": _vm.countries,
        },
        on: {
          input: function ($event) {
            _vm.selectedCountry = $event[0]
            _vm.$emit("selectedCountry", $event[0])
          },
        },
      }),
      _vm._v(" "),
      _vm.selectedCountry
        ? _c(
            "mds-button",
            {
              staticClass: "holidays-field__button-list",
              attrs: { size: "small", variation: "flat" },
              on: {
                click: function ($event) {
                  _vm.showHolidays = !_vm.showHolidays
                },
              },
            },
            [_vm._v("\n    List of " + _vm._s(_vm.modalTitle) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "mds-modal",
        {
          staticClass: "holidays-field__modal-list",
          attrs: { "action-required": "" },
          model: {
            value: _vm.showHolidays,
            callback: function ($$v) {
              _vm.showHolidays = $$v
            },
            expression: "showHolidays",
          },
        },
        [
          _c(
            "mds-section",
            {
              staticClass: "holidays-field__section",
              attrs: {
                bold: "",
                border: "none",
                size: 7,
                title: _vm.modalTitle,
              },
              scopedSlots: _vm._u([
                {
                  key: "mds-section-actions",
                  fn: function () {
                    return [
                      _c("mds-button", {
                        staticClass: "holidays-field__close-button",
                        attrs: { variation: "icon-only", icon: "remove" },
                        on: {
                          click: function ($event) {
                            _vm.showHolidays = !_vm.showHolidays
                          },
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _c(
                "mds-table",
                [
                  _c(
                    "mds-tbody",
                    { staticClass: "holidays-field__table-body" },
                    _vm._l(_vm.holidays, function ({ date, name }, index) {
                      return _c(
                        "mds-tr",
                        { key: index },
                        [
                          _c(
                            "mds-td",
                            { staticClass: "holidays-field__table-cell" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(date) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "mds-td",
                            { staticClass: "holidays-field__table-cell" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(name) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }